import React from "react";
import { Albums, AlbumType } from "./Albums";
import { useAdvancedState } from "../../hooks/use-advanced-state";
import { Tracks } from "./Tracks";
import { Drafts } from "./Drafts";
import { useTranslation } from "../../hooks/useTranslation";

export enum MusicPageContentType {
  ALBUMS = "ALBUMS",
  TRACKS = "TRACKS",
  DRAFTS = "DRAFTS",
}

type Props = {
  contentType: MusicPageContentType;
};

export const MusicPage: React.FC<Props> = ({ contentType }) => {
  const { t } = useTranslation();
  const [counts, setCounts, updateCount] = useAdvancedState<{
    totalCount: string | number | null;
    contentCount: string | null | number;
  }>({
    totalCount: null,
    contentCount: null,
  });

  return (
    <div className={"w-100"}>
      <div className={"mb-3"}>
        <span className={"font-bold text-2xl dark:text-white"}>
          {t("sidebar_" + contentType)}
        </span>{" "}
        <span className={"text-gray-500 font-bold dark:text-white"}>
          ({counts.contentCount} / {counts.totalCount})
        </span>
      </div>

      {contentType === MusicPageContentType.ALBUMS && (
        <Albums
          type={AlbumType.AUDIO}
          onChange={(totalCount, contentCount) =>
            updateCount({ totalCount, contentCount })
          }
        />
      )}
      {contentType === MusicPageContentType.TRACKS && (
        <Tracks
          onChange={(totalCount, contentCount) =>
            updateCount({ totalCount, contentCount })
          }
        />
      )}
      {contentType === MusicPageContentType.DRAFTS && (
        <Drafts
          type={AlbumType.AUDIO}
          onChange={(totalCount, contentCount) =>
            updateCount({ totalCount, contentCount })
          }
        />
      )}
    </div>
  );
};
